/**
 * Accept both the bare-string list the AI recommendation payload ships and
 * `{ id, label }` objects; always return `{ id, label }`.
 */
export const normalizeSuggestions = (items = []) =>
    (Array.isArray(items) ? items : [])
        .filter((item) => item != null && item !== '')
        .map((item) =>
            typeof item === 'object'
                ? { id: String(item.id ?? item.value ?? item.label ?? item.text), label: item.label ?? item.text ?? String(item.id) }
                : { id: String(item), label: String(item) },
        );

export const toIdSet = (ids) => {
    if (ids instanceof Set) return ids;
    if (Array.isArray(ids)) return new Set(ids.map(String));
    if (ids && typeof ids === 'object') return new Set(Object.keys(ids).filter((key) => ids[key]));
    return new Set();
};
